import { AppHeader, AppMenu, AppSidebar, AppBreadcrumb } from 'components'
import {loadMenuByParentPath, searchChildMenuItemListByParentId} from '@/utils/menu'
import {getSystemMenuList} from '@/api/get-data'
import ssoLoginMixin from '@/mixins/sso-login-mixin.js'

export default {
  name: 'layoutHome',
  data () {
    return {
      rootPath: '/home',
      sideBarMenu: null,
      sideBarMenuCurrentItem: null,
      breadcrumb: [{name: '首页', path: this.rootPath}]
    }
  },
  components: {
    AppHeader,
    AppMenu,
    AppSidebar,
    AppBreadcrumb
  },
  mixins: [
    ssoLoginMixin
  ],
  computed: {
    sideBarOpen () {
      return this.$store.getters.appSideBarOpen
    }
  },
  watch: {
  },
  created() {
    // 单点登录（如url包含code和uiapTpye参数则启用单点登录）
    this.ssoLogin(this.$route.query.code, this.$route.query.uiapType).then(res => {
      getSystemMenuList(() => { // 读取系统菜单列表
        this.$globalData.systemMenus.forEach(item => {
          if (!item.iconLoaded) {
            item.icon = '/static/img/menu/' + item.icon
            item.iconLoaded = true
          }
        })
        // 加载顶层菜单数组
        this.loadAppMenu()
        // 加载侧边栏菜单
        this.loadSideBarMenu()
      })
    })
  },
  mounted () {
    this.$nextTick(() => {
      this.setLayout()
    })
  },
  methods: {
    // 加载顶层菜单数组
    loadAppMenu() {
      let childMenus = searchChildMenuItemListByParentId(0, false, this.$globalData.systemMenus)
      if (childMenus.length) {
        let childMenus2 = []
        childMenus.forEach(item => {
          childMenus2.push({
            id: item.id,
            key: item.path.length && item.path[0] === '/' ? item.path.slice(1) : item.path,
            query: item.query,
            value: item.name,
            icon: item.icon,
            children: []
          })
        })
        this.$refs.appMenu.menu = childMenus2
      }
    },
    // 加载侧边栏菜单
    loadSideBarMenu() {
      let menuTree = loadMenuByParentPath(this.rootPath, this.$globalData.systemMenus)
      if (menuTree) {
        this.sideBarMenu = menuTree.children
      }
    },
    setLayout () {
      this.sideBarMenuCurrentItem = this.$route.name
      this.$store.commit('app/SET_SIDEBAR_MENU_CURRENT_ITEM', this.sideBarMenuCurrentItem)
      this.getBreadcrumbData(this.sideBarMenuCurrentItem, this.sideBarMenu)
    },
    handleSelectSideBarMenuItem (val) {
      this.sideBarMenuCurrentItem = val
      this.$store.commit('app/SET_SIDEBAR_MENU_CURRENT_ITEM', val)
      this.getBreadcrumbData(val, this.sideBarMenu)
    },
    // 获取面包屑导航组件数据
    getBreadcrumbData (key, menu) {
      if (!menu) {
        return
      }
      menu.forEach(item => {
        if (key === item.key) {
          this.breadcrumb[1] = {name: item.value, path: null}
          this.breadcrumb.splice(2, 1)
        }
        if (item.children && item.children.length) {
          item.children.forEach(cItem => {
            if (key === cItem.key) {
              this.breadcrumb[1] = {name: item.value, path: this.rootPath + '/' + item.children[0].key}
              this.breadcrumb[2] = {name: cItem.value, path: null}
            }
          })
        }
      })
      this.breadcrumb = this.breadcrumb.slice(0)
    }
  },
  beforeDestroy () {
    this.$store.commit('app/SET_HEADER_MENU_CURRENT_ITEM', '')
    this.$store.commit('app/SET_SIDEBAR_MENU_CURRENT_ITEM', '')
  }
}



// WEBPACK FOOTER //
// ./src/layouts/layoutHome/LayoutHome.js